__turbopack_context__.v({
  "alignRight": "_7xAXIW_alignRight",
  "alignRightContent": "_7xAXIW_alignRightContent",
  "closeBtn": "_7xAXIW_closeBtn",
  "closeNBtn": "_7xAXIW_closeNBtn",
  "darkBg": "_7xAXIW_darkBg",
  "filled": "_7xAXIW_filled",
  "fullViewBackdrop": "_7xAXIW_fullViewBackdrop",
  "fullViewMobile": "_7xAXIW_fullViewMobile",
  "light": "_7xAXIW_light",
  "modalContent": "_7xAXIW_modalContent",
  "modalContentSlideUp": "_7xAXIW_modalContentSlideUp",
  "modalFadeIn": "_7xAXIW_modalFadeIn",
  "root": "_7xAXIW_root",
  "top": "_7xAXIW_top",
});
